// MIT License. See license.txt

// provide a namespace
if (!window.tuduno) window.tuduno = {};

tuduno.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

tuduno.provide("locals");
tuduno.provide("tuduno.flags");
tuduno.provide("tuduno.settings");
tuduno.provide("tuduno.utils");
tuduno.provide("tuduno.ui.form");
tuduno.provide("tuduno.modules");
tuduno.provide("tuduno.templates");
tuduno.provide("tuduno.test_data");
tuduno.provide("tuduno.utils");
tuduno.provide("tuduno.model");
tuduno.provide("tuduno.user");
tuduno.provide("tuduno.session");
tuduno.provide("tuduno._messages");
tuduno.provide("locals.DocType");

// for listviews
tuduno.provide("tuduno.listview_settings");
tuduno.provide("tuduno.tour");
tuduno.provide("tuduno.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
